// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== RESET ==================== */

*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
  font: inherit;
}

body {
  margin: 0;
  min-height: 100vh;
}

img {
  display: block;
}

/* ==================== COLOR KNOBS ==================== */

:root {
  --board-bg: #0f172a;
  --border-color: #1e293b;
  --grid-line: rgba(255, 255, 255, 0.05);

  --ship: #3b82f6;
  --hit: #ef4444;
  --miss: #38bdf8;

  --text: #e2e8f0;

  --safe: #22c55e;
  --caution: #84cc16;
  --danger: #f59e0b;
}

/* ==================== ROOT LAYOUT ==================== */

#root {
  min-height: 100vh;
  display: flex;
}

/* ==================== MENU SCREEN ==================== */

.menu-screen {
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: #020617;
}

.menu-card {
  background-color: #020617;

  border-radius: 12px;

  padding: 40px;

  width: min(420px, 90%);

  display: flex;
  flex-direction: column;
  gap: 28px;

  box-shadow:
    0 10px 25px rgba(0, 0, 0, 0.5),
    inset 0 0 10px rgba(255, 255, 255, 0.05);
}

.menu-title {
  font-size: 2.8rem;
  text-align: center;
  color: #e2e8f0;
}

.menu-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 0.9rem;
  color: #94a3b8;
}

.form-group input,
.form-group select {
  padding: 10px;

  border-radius: 6px;

  border: 1px solid #334155;

  background-color: #0f172a;

  color: #e2e8f0;
}

.start-button {
  padding: 12px;

  border: none;

  border-radius: 8px;

  background-color: #22c55e;

  color: #022c22;

  font-weight: 600;

  cursor: pointer;

  transition: background-color 0.15s ease;
}

.start-button:hover {
  background-color: #16a34a;
}

/* ==================== BOARD ==================== */

.board {
  display: grid;

  grid-template-columns: repeat(10, 50px);
  grid-template-rows: repeat(10, 50px);

  border: 1px solid var(--border-color);

  background-color: #020617;

  padding: 20px;

  border-radius: 12px;

  box-shadow:
    0 10px 25px rgba(0, 0, 0, 0.5),
    inset 0 0 10px rgba(255, 255, 255, 0.06);
}

/* ==================== CELLS ==================== */

.cell {
  min-width: 40px;
  min-height: 40px;

  border: 1px solid var(--grid-line);

  background-color: var(--board-bg);

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: default;

  transition: all 0.15s ease;
}

.cell.hover:not([data-flag]) {
  box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.8);
  cursor: pointer;
}

/* ==================== SHIPS ==================== */

.ship-unit {
  background-color: var(--ship);

  border-radius: 4px;

  box-shadow: inset 0 -3px 0 rgba(0, 0, 0, 0.3);
}

/* ==================== ATTACK RESULTS ==================== */

.cell[data-flag="hit"] {
  background-color: var(--hit);

  border-radius: 4px;

  box-shadow: inset 0 -3px 0 rgba(0, 0, 0, 0.3);

  animation: attackFlash 0.25s;
}

.cell[data-flag="hit"]::after {
  content: "✕";
  color: white;
  font-weight: bold;
}

.cell[data-flag="miss"] {
  background-color: var(--board-bg);
}

.cell[data-flag="miss"]::after {
  content: "•";
  color: var(--miss);
  font-size: 2rem;
}

/* ==================== HEALTH BARS ==================== */

.health-bar-shell {
  width: 100%;

  height: 20px;

  background-color: var(--border-color);

  border-radius: 10px;

  overflow: hidden;
}

.health-bar-fill {
  height: 100%;

  transition: width 0.3s ease;
}

.health-bar-fill[data-status="safe"] {
  background-color: var(--safe);
}

.health-bar-fill[data-status="caution"] {
  background-color: var(--caution);
}

.health-bar-fill[data-status="danger"] {
  background-color: var(--danger);

  box-shadow: 0 0 8px red;
}

/* ==================== PLACEMENT ==================== */

.placement-screen {
  flex: 1;

  display: flex;
  flex-direction: column;

  align-items: center;

  padding-top: 40px;

  gap: 24px;
}

.placement-header {
  text-align: center;
}

.placement-title {
  font-size: 1.6rem;
  margin-bottom: 6px;
}

.placement-help {
  font-size: 0.9rem;
  opacity: 0.75;
}

.placement-layout {
  display: flex;

  align-items: flex-start;

  gap: 48px;
}

.placement-board-area {
  display: flex;
  justify-content: center;
}

.placement-panel {
  display: flex;
  flex-direction: column;

  gap: 24px;

  min-width: 240px;
}

.ship-preview-panel {
  background-color: #020617;

  border-radius: 12px;

  padding: 24px;

  display: flex;
  flex-direction: column;

  align-items: center;

  gap: 12px;

  min-width: 260px;
  min-height: 260px;
}

.preview-label {
  font-size: 14px;
  opacity: 0.75;
  color: white;
}

#current-ship-display {
  min-width: 280px;
  min-height: 280px;

  padding: 24px;

  display: grid;

  grid-auto-columns: 40px;
  grid-auto-rows: 40px;

  justify-content: center;
  align-content: center;

  margin: auto 0;
}

#current-ship-display[data-orientation="horizontal"] {
  grid-auto-flow: column;
}

#current-ship-display[data-orientation="vertical"] {
  grid-auto-flow: row;
}

.placement-controls {
  display: flex;
  flex-direction: column;

  gap: 12px;
}

.placement-controls button {
  padding: 10px;

  border: none;

  border-radius: 8px;

  background-color: #1e293b;

  color: #e2e8f0;

  cursor: pointer;

  transition: background-color 0.15s ease;
}

.placement-controls button:hover {
  background-color: #334155;
}

.placement-controls .confirm-btn:not(:disabled) {
  background-color: #22c55e;
  color: #022c22;

  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);

  transition:
    background-color 0.15s ease,
    transform 0.1s ease,
    box-shadow 0.15s ease;
  box-shadow: 0 6px 16px rgba(34, 197, 94, 0.45);
}

.placement-controls .confirm-btn:disabled {
  background-color: #1e293b;
  color: white;
  opacity: 0.5;
  cursor: not-allowed;
}

.placement-controls .confirm-btn:hover:not(:disabled) {
  background-color: #16a34a;
  animation: none;
}

.valid-place {
  background-color: var(--safe);
}

.invalid-place {
  background-color: var(--danger);
}

/* ==================== COMBAT ==================== */

.combat-screen {
  flex: 1;

  display: flex;
  flex-direction: column;

  align-items: center;

  padding: 60px;

  gap: 24px;
}

.combat-header {
  text-align: center;
}

.combat-header h1 {
  font-size: 4rem;
}

#turn-indicator {
  font-size: 1.4rem;
  color: #38bdf8;
}

.combat-layout {
  display: flex;

  gap: 60px;

  align-items: flex-start;
}

.fleet-panel {
  display: flex;
  flex-direction: column;

  gap: 16px;

  align-items: center;
}

#player-name-bar,
#computer-name-bar {
  font-weight: 600;
}

/* ==================== MODAL ==================== */

dialog {
  position: fixed;

  min-width: min(90%, 600px);

  margin: auto;

  padding: 40px 56px;

  border: 2px solid black;

  border-radius: 12px;

  background-color: #04091b;

  text-align: center;

  animation: modalEnter 0.25s ease;
}

dialog::backdrop {
  background-color: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(4px);
}

#game-over-panel[data-status="victory"] {
  color: #22c55e;
}

#game-over-panel[data-status="defeat"] {
  color: #ef4444;
}

#game-over-title {
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 10px;
}

#game-over-message {
  font-size: 1rem;
  opacity: 0.8;
}

.modal-buttons {
  display: flex;

  gap: 12px;

  justify-content: center;

  margin-top: 20px;
}

.modal-buttons button {
  padding: 10px 18px;

  border: none;

  border-radius: 8px;

  background-color: #1e293b;

  color: #e2e8f0;

  cursor: pointer;
}

.modal-buttons button:hover {
  background-color: #334155;
}

#restart-game {
  background-color: #22c55e;
  color: #022c22;
}

/* ==================== ANIMATIONS ==================== */

@keyframes attackFlash {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes modalEnter {
  from {
    opacity: 0;
    transform: scale(0.9);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,0DAA0D;;AAE1D;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;;EAEtC,eAAe;EACf,cAAc;EACd,eAAe;;EAEf,eAAe;;EAEf,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,0DAA0D;;AAE1D;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA,0DAA0D;;AAE1D;EACE,OAAO;;EAEP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;;EAEzB,mBAAmB;;EAEnB,aAAa;;EAEb,sBAAsB;;EAEtB,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;;4CAE0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,aAAa;;EAEb,kBAAkB;;EAElB,yBAAyB;;EAEzB,yBAAyB;;EAEzB,cAAc;AAChB;;AAEA;EACE,aAAa;;EAEb,YAAY;;EAEZ,kBAAkB;;EAElB,yBAAyB;;EAEzB,cAAc;;EAEd,gBAAgB;;EAEhB,eAAe;;EAEf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oDAAoD;;AAEpD;EACE,aAAa;;EAEb,uCAAuC;EACvC,oCAAoC;;EAEpC,qCAAqC;;EAErC,yBAAyB;;EAEzB,aAAa;;EAEb,mBAAmB;;EAEnB;;4CAE0C;AAC5C;;AAEA,oDAAoD;;AAEpD;EACE,eAAe;EACf,gBAAgB;;EAEhB,kCAAkC;;EAElC,iCAAiC;;EAEjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;;EAEf,0BAA0B;AAC5B;;AAEA;EACE,mDAAmD;EACnD,eAAe;AACjB;;AAEA,oDAAoD;;AAEpD;EACE,6BAA6B;;EAE7B,kBAAkB;;EAElB,6CAA6C;AAC/C;;AAEA,6DAA6D;;AAE7D;EACE,4BAA4B;;EAE5B,kBAAkB;;EAElB,6CAA6C;;EAE7C,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,0DAA0D;;AAE1D;EACE,WAAW;;EAEX,YAAY;;EAEZ,qCAAqC;;EAErC,mBAAmB;;EAEnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;;EAEZ,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;;EAE/B,uBAAuB;AACzB;;AAEA,wDAAwD;;AAExD;EACE,OAAO;;EAEP,aAAa;EACb,sBAAsB;;EAEtB,mBAAmB;;EAEnB,iBAAiB;;EAEjB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;;EAEb,uBAAuB;;EAEvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB,SAAS;;EAET,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;;EAEzB,mBAAmB;;EAEnB,aAAa;;EAEb,aAAa;EACb,sBAAsB;;EAEtB,mBAAmB;;EAEnB,SAAS;;EAET,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;;EAEjB,aAAa;;EAEb,aAAa;;EAEb,uBAAuB;EACvB,oBAAoB;;EAEpB,uBAAuB;EACvB,qBAAqB;;EAErB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB,SAAS;AACX;;AAEA;EACE,aAAa;;EAEb,YAAY;;EAEZ,kBAAkB;;EAElB,yBAAyB;;EAEzB,cAAc;;EAEd,eAAe;;EAEf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;;EAEd,6CAA6C;;EAE7C;;;yBAGuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,qDAAqD;;AAErD;EACE,OAAO;;EAEP,aAAa;EACb,sBAAsB;;EAEtB,mBAAmB;;EAEnB,aAAa;;EAEb,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;;EAEb,SAAS;;EAET,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB,SAAS;;EAET,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,oDAAoD;;AAEpD;EACE,eAAe;;EAEf,0BAA0B;;EAE1B,YAAY;;EAEZ,kBAAkB;;EAElB,uBAAuB;;EAEvB,mBAAmB;;EAEnB,yBAAyB;;EAEzB,kBAAkB;;EAElB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;;EAEb,SAAS;;EAET,uBAAuB;;EAEvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;;EAElB,YAAY;;EAEZ,kBAAkB;;EAElB,yBAAyB;;EAEzB,cAAc;;EAEd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,yDAAyD;;AAEzD;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":["/* ==================== RESET ==================== */\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n  font: inherit;\n}\n\nbody {\n  margin: 0;\n  min-height: 100vh;\n}\n\nimg {\n  display: block;\n}\n\n/* ==================== COLOR KNOBS ==================== */\n\n:root {\n  --board-bg: #0f172a;\n  --border-color: #1e293b;\n  --grid-line: rgba(255, 255, 255, 0.05);\n\n  --ship: #3b82f6;\n  --hit: #ef4444;\n  --miss: #38bdf8;\n\n  --text: #e2e8f0;\n\n  --safe: #22c55e;\n  --caution: #84cc16;\n  --danger: #f59e0b;\n}\n\n/* ==================== ROOT LAYOUT ==================== */\n\n#root {\n  min-height: 100vh;\n  display: flex;\n}\n\n/* ==================== MENU SCREEN ==================== */\n\n.menu-screen {\n  flex: 1;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background-color: #020617;\n}\n\n.menu-card {\n  background-color: #020617;\n\n  border-radius: 12px;\n\n  padding: 40px;\n\n  width: min(420px, 90%);\n\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n\n  box-shadow:\n    0 10px 25px rgba(0, 0, 0, 0.5),\n    inset 0 0 10px rgba(255, 255, 255, 0.05);\n}\n\n.menu-title {\n  font-size: 2.8rem;\n  text-align: center;\n  color: #e2e8f0;\n}\n\n.menu-form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.form-group label {\n  font-size: 0.9rem;\n  color: #94a3b8;\n}\n\n.form-group input,\n.form-group select {\n  padding: 10px;\n\n  border-radius: 6px;\n\n  border: 1px solid #334155;\n\n  background-color: #0f172a;\n\n  color: #e2e8f0;\n}\n\n.start-button {\n  padding: 12px;\n\n  border: none;\n\n  border-radius: 8px;\n\n  background-color: #22c55e;\n\n  color: #022c22;\n\n  font-weight: 600;\n\n  cursor: pointer;\n\n  transition: background-color 0.15s ease;\n}\n\n.start-button:hover {\n  background-color: #16a34a;\n}\n\n/* ==================== BOARD ==================== */\n\n.board {\n  display: grid;\n\n  grid-template-columns: repeat(10, 50px);\n  grid-template-rows: repeat(10, 50px);\n\n  border: 1px solid var(--border-color);\n\n  background-color: #020617;\n\n  padding: 20px;\n\n  border-radius: 12px;\n\n  box-shadow:\n    0 10px 25px rgba(0, 0, 0, 0.5),\n    inset 0 0 10px rgba(255, 255, 255, 0.06);\n}\n\n/* ==================== CELLS ==================== */\n\n.cell {\n  min-width: 40px;\n  min-height: 40px;\n\n  border: 1px solid var(--grid-line);\n\n  background-color: var(--board-bg);\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  cursor: default;\n\n  transition: all 0.15s ease;\n}\n\n.cell.hover:not([data-flag]) {\n  box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.8);\n  cursor: pointer;\n}\n\n/* ==================== SHIPS ==================== */\n\n.ship-unit {\n  background-color: var(--ship);\n\n  border-radius: 4px;\n\n  box-shadow: inset 0 -3px 0 rgba(0, 0, 0, 0.3);\n}\n\n/* ==================== ATTACK RESULTS ==================== */\n\n.cell[data-flag=\"hit\"] {\n  background-color: var(--hit);\n\n  border-radius: 4px;\n\n  box-shadow: inset 0 -3px 0 rgba(0, 0, 0, 0.3);\n\n  animation: attackFlash 0.25s;\n}\n\n.cell[data-flag=\"hit\"]::after {\n  content: \"✕\";\n  color: white;\n  font-weight: bold;\n}\n\n.cell[data-flag=\"miss\"] {\n  background-color: var(--board-bg);\n}\n\n.cell[data-flag=\"miss\"]::after {\n  content: \"•\";\n  color: var(--miss);\n  font-size: 2rem;\n}\n\n/* ==================== HEALTH BARS ==================== */\n\n.health-bar-shell {\n  width: 100%;\n\n  height: 20px;\n\n  background-color: var(--border-color);\n\n  border-radius: 10px;\n\n  overflow: hidden;\n}\n\n.health-bar-fill {\n  height: 100%;\n\n  transition: width 0.3s ease;\n}\n\n.health-bar-fill[data-status=\"safe\"] {\n  background-color: var(--safe);\n}\n\n.health-bar-fill[data-status=\"caution\"] {\n  background-color: var(--caution);\n}\n\n.health-bar-fill[data-status=\"danger\"] {\n  background-color: var(--danger);\n\n  box-shadow: 0 0 8px red;\n}\n\n/* ==================== PLACEMENT ==================== */\n\n.placement-screen {\n  flex: 1;\n\n  display: flex;\n  flex-direction: column;\n\n  align-items: center;\n\n  padding-top: 40px;\n\n  gap: 24px;\n}\n\n.placement-header {\n  text-align: center;\n}\n\n.placement-title {\n  font-size: 1.6rem;\n  margin-bottom: 6px;\n}\n\n.placement-help {\n  font-size: 0.9rem;\n  opacity: 0.75;\n}\n\n.placement-layout {\n  display: flex;\n\n  align-items: flex-start;\n\n  gap: 48px;\n}\n\n.placement-board-area {\n  display: flex;\n  justify-content: center;\n}\n\n.placement-panel {\n  display: flex;\n  flex-direction: column;\n\n  gap: 24px;\n\n  min-width: 240px;\n}\n\n.ship-preview-panel {\n  background-color: #020617;\n\n  border-radius: 12px;\n\n  padding: 24px;\n\n  display: flex;\n  flex-direction: column;\n\n  align-items: center;\n\n  gap: 12px;\n\n  min-width: 260px;\n  min-height: 260px;\n}\n\n.preview-label {\n  font-size: 14px;\n  opacity: 0.75;\n  color: white;\n}\n\n#current-ship-display {\n  min-width: 280px;\n  min-height: 280px;\n\n  padding: 24px;\n\n  display: grid;\n\n  grid-auto-columns: 40px;\n  grid-auto-rows: 40px;\n\n  justify-content: center;\n  align-content: center;\n\n  margin: auto 0;\n}\n\n#current-ship-display[data-orientation=\"horizontal\"] {\n  grid-auto-flow: column;\n}\n\n#current-ship-display[data-orientation=\"vertical\"] {\n  grid-auto-flow: row;\n}\n\n.placement-controls {\n  display: flex;\n  flex-direction: column;\n\n  gap: 12px;\n}\n\n.placement-controls button {\n  padding: 10px;\n\n  border: none;\n\n  border-radius: 8px;\n\n  background-color: #1e293b;\n\n  color: #e2e8f0;\n\n  cursor: pointer;\n\n  transition: background-color 0.15s ease;\n}\n\n.placement-controls button:hover {\n  background-color: #334155;\n}\n\n.placement-controls .confirm-btn:not(:disabled) {\n  background-color: #22c55e;\n  color: #022c22;\n\n  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);\n\n  transition:\n    background-color 0.15s ease,\n    transform 0.1s ease,\n    box-shadow 0.15s ease;\n  box-shadow: 0 6px 16px rgba(34, 197, 94, 0.45);\n}\n\n.placement-controls .confirm-btn:disabled {\n  background-color: #1e293b;\n  color: white;\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.placement-controls .confirm-btn:hover:not(:disabled) {\n  background-color: #16a34a;\n  animation: none;\n}\n\n.valid-place {\n  background-color: var(--safe);\n}\n\n.invalid-place {\n  background-color: var(--danger);\n}\n\n/* ==================== COMBAT ==================== */\n\n.combat-screen {\n  flex: 1;\n\n  display: flex;\n  flex-direction: column;\n\n  align-items: center;\n\n  padding: 60px;\n\n  gap: 24px;\n}\n\n.combat-header {\n  text-align: center;\n}\n\n.combat-header h1 {\n  font-size: 4rem;\n}\n\n#turn-indicator {\n  font-size: 1.4rem;\n  color: #38bdf8;\n}\n\n.combat-layout {\n  display: flex;\n\n  gap: 60px;\n\n  align-items: flex-start;\n}\n\n.fleet-panel {\n  display: flex;\n  flex-direction: column;\n\n  gap: 16px;\n\n  align-items: center;\n}\n\n#player-name-bar,\n#computer-name-bar {\n  font-weight: 600;\n}\n\n/* ==================== MODAL ==================== */\n\ndialog {\n  position: fixed;\n\n  min-width: min(90%, 600px);\n\n  margin: auto;\n\n  padding: 40px 56px;\n\n  border: 2px solid black;\n\n  border-radius: 12px;\n\n  background-color: #04091b;\n\n  text-align: center;\n\n  animation: modalEnter 0.25s ease;\n}\n\ndialog::backdrop {\n  background-color: rgba(0, 0, 0, 0.65);\n  backdrop-filter: blur(4px);\n}\n\n#game-over-panel[data-status=\"victory\"] {\n  color: #22c55e;\n}\n\n#game-over-panel[data-status=\"defeat\"] {\n  color: #ef4444;\n}\n\n#game-over-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n\n#game-over-message {\n  font-size: 1rem;\n  opacity: 0.8;\n}\n\n.modal-buttons {\n  display: flex;\n\n  gap: 12px;\n\n  justify-content: center;\n\n  margin-top: 20px;\n}\n\n.modal-buttons button {\n  padding: 10px 18px;\n\n  border: none;\n\n  border-radius: 8px;\n\n  background-color: #1e293b;\n\n  color: #e2e8f0;\n\n  cursor: pointer;\n}\n\n.modal-buttons button:hover {\n  background-color: #334155;\n}\n\n#restart-game {\n  background-color: #22c55e;\n  color: #022c22;\n}\n\n/* ==================== ANIMATIONS ==================== */\n\n@keyframes attackFlash {\n  0% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.2);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes modalEnter {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
